import React from 'react';
export const EmptyRow = ({
  virtualRow,
  className,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    "data-empty-row": "true",
    key: `empty_row_${virtualRow.index}`,
    className: className,
    style: {
      height: `${virtualRow.size}px`,
      transform: `translateY(${virtualRow.start}px)`,
      boxSizing: 'border-box'
    }
  }, children);
};